import { render } from "./remote_follow.vue?vue&type=template&id=2aed8421"
import script from "./remote_follow.js?vue&type=script&lang=js"
export * from "./remote_follow.js?vue&type=script&lang=js"

import "./remote_follow.vue?vue&type=style&index=0&id=2aed8421&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__